import fromTypes from "../actions/types";
import { ofType } from "redux-observable";
import { mergeMap, catchError, filter, switchMap, tap } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { authHeaders, tokenExists, getOrganisationBaseUrl, getBaseUrl } from "frame";
import { push } from "connected-react-router";
import { getCurrentTimestamp } from "utils";

// Define hardcoded action types
const CREATE_REQUESTED = "SITE_INSPECTION_CHECKLIST_CREATE_REQUESTED";
const CREATE_SUCCESS = "SITE_INSPECTION_CHECKLIST_CREATE_SUCCESS";
const CREATE_FAILED = "SITE_INSPECTION_CHECKLIST_CREATE_FAILED";

// Create direct action creators
const createSuccess = (payload) => ({
    type: CREATE_SUCCESS,
    payload
});

const createFailed = (error) => ({
    type: CREATE_FAILED,
    payload: { error }
});

// Log the expected action type
console.log("DEBUG - Expected action type for create effect:", CREATE_REQUESTED);

const siteInspectionChecklistCreateEffect = (action$, state$) =>
    action$.pipe(
        // Add tap to see all actions
        tap(action => console.log("DEBUG - Action received in site inspection effect:", action.type)),
        ofType(CREATE_REQUESTED, "SITE_INSPECTION_CHECKLIST_CREATE_REQUESTED"), // Try both formats
        tap(action => console.log("DEBUG - Create action matched and picked up by effect:", action)),
        filter(() => {
            const hasToken = tokenExists();
            console.log("DEBUG - tokenExists:", hasToken);
            return hasToken;
        }),
        filter(() => {
            const hasOrg = !!state$.value.organisations.currentOrganisation;
            console.log("DEBUG - has currentOrganisation:", hasOrg);
            return hasOrg;
        }),
        filter(() => {
            const hasNetwork = state$.value.queue.hasNetwork;
            console.log("DEBUG - hasNetwork:", hasNetwork);
            return hasNetwork;
        }),
        switchMap(({ payload }) => {
            console.log("DEBUG - Create/Update Site Inspection Checklist Effect - payload:", payload);
            
            // Debug the full organizations state
            console.log("DEBUG - Full organizations state:", state$.value.organisations);
            
            // Get the organization ID with more detailed logging
            let organisationId = null;
            try {
                // Check if currentOrganisation exists and has an id
                if (state$.value.organisations && 
                    state$.value.organisations.currentOrganisation && 
                    state$.value.organisations.currentOrganisation.id) {
                    organisationId = state$.value.organisations.currentOrganisation.id;
                } else {
                    // Fallback: check if we have a list of organizations and use the first one
                    if (state$.value.organisations && 
                        state$.value.organisations.list && 
                        state$.value.organisations.list.length > 0) {
                        organisationId = state$.value.organisations.list[0].id;
                        console.log("DEBUG - Using first organization from list:", organisationId);
                    }
                }
            } catch (error) {
                console.error("DEBUG - Error getting organization ID:", error);
            }
            
            console.log("DEBUG - organisationId:", organisationId);
            
            // Fallback to a hardcoded value if still undefined (for debugging only)
            if (!organisationId) {
                console.error("DEBUG - Organization ID is still undefined, using the one from the error message");
                organisationId = "2c3427a6-c626-4963-8675-542922086b1b"; // Using the ID from your error message
            }
            
            if (!payload || !payload.siteId) {
                console.error("DEBUG - Error: No site ID provided in payload");
                return of(createFailed(new Error("No site ID provided")));
            }
            
            // Use the updated getOrganisationBaseUrl function
            const baseUrl = getBaseUrl();
            console.log("DEBUG - Base URL from getBaseUrl:", baseUrl);
            
            // Use the updated getOrganisationBaseUrl function
            const correctApiUrl = `${getOrganisationBaseUrl(state$.value)}/site-inspection-checklists/createorupdate`;
            console.log("DEBUG - Correct API URL:", correctApiUrl);

            // Enrich payload with creator and standard health & safety metadata
            const profile = state$.value.profile || {};
            const creatorId =
                profile.userId || profile.id || profile.staffId || "";
            const creatorName =
                profile.fullName ||
                `${profile.firstName || ""} ${profile.lastName || ""}`.trim();

            const body = {
                ...payload,
                creatorId,
                creatorName,
                organisationId: state$.value.organisations.currentOrganisation,
                latitude: state$.value.geolocation.latitude,
                longitude: state$.value.geolocation.longitude,
                timestamp: getCurrentTimestamp(),
            };
            
            return ajax
                .post(
                    correctApiUrl,
                    body,
                    authHeaders()
                )
                .pipe(
                    mergeMap((ajaxResponse) => {
                        console.log("DEBUG - Site inspection checklist created/updated successfully. Response:", ajaxResponse.response);
                        
                        // Create success action with hardcoded type
                        const successAction = createSuccess(ajaxResponse.response);
                        console.log("DEBUG - Success action:", successAction);
                        
                        // Return the success action only
                        return of(successAction);
                    }),
                    catchError((error) => {
                        console.error("DEBUG - Error creating/updating site inspection checklist:", error);
                        console.error("DEBUG - Error details:", error.response ? error.response : error.message);
                        return of(createFailed(error));
                    })
                );
        })
    );

export default siteInspectionChecklistCreateEffect; 